// hero slider 
$(document).ready(function(){
    hero_slider();
    product_slider();
    upsell_slider();
    collection_item_slider();
    review_slider(); 

    // product tab 
    $('.product-tab-item').on('click', function(){
        var id = $(this).data('id');
        $(this).addClass('active').siblings().removeClass('active');
        $('#tab_'+id).addClass('show').siblings().removeClass('show');
        $('.product-contents-slider').slick('setPosition');
        product_slider();
    })

    // size guide 
    $('span.size-quide-btn').on('click', function(){
        $('.size-quide').fadeIn();
    })

    $('.size-guide-close, .size-guide-overly').on('click', function(){
        $('.size-quide').fadeOut();
    })

    // cart dreawer 
    $('.header_cart').on('click', function(e){
        e.preventDefault();
        $('body').addClass('cartshown');
    })
    $('.cart-drawer-close, .cart-drawer-overly').on('click', function(){
        $('body').removeClass('cartshown');
    })

    $('.card-variant-input').on('click', function(){
        var src = $(this).data('img');
        if(typeof src !== "undefined" ) {
          $(this).parent().parent().parent().find('.product-card-img').attr('src', src).attr('srcset', src);
        }
       
        // console.log('src ' + src)
    })

    // product page custom properties
    $('.lens-item').on('change', function () {
      var id = $(this).val();
      var prescription_selector = $('#prescription_selector option:selected').val();
      var lens_selector = $('#lens_selector option:selected').val();
      if(id == 1) {
        $('.child-level').slideDown();
        $('#prescription_type').val(prescription_selector);
        $('#lens_specification').val(lens_selector);
      }else{
        $('.child-level').slideUp();
        $('#prescription_file, #prescription_type, #lens_specification').val('');
        $('#file_preview').html('');
        $('.prescription-btn').text('Choose File');
      }
    });

    $('.lens_type').on('change', function () {
      if ($('.choose-lens-power').is(':checked')) {
          $('.child-level').slideDown();
      } else {
        $('.child-level').slideUp();
      }
    });


    // clicking the button when the full-box is clicked
    $('.lens-option .card').on('click',function(e){
      $(this).find('.btn').click();
    })

    // cart-drawer customer cosnent
    $(document).on("click", "#terms", function () {
      if ($(this).is(":checked")) {
        $(".cart-checkout-btn").removeClass("disabled");
      } else {
        $(".cart-checkout-btn").addClass("disabled");
      }
    });
    
    // span will work like label of the customer consent
    $(document).on('click', '.consent-wrapper .checkbox-text', function () {
      $(this).closest('.consent').find('input[type="checkbox"]').click();
    });


})

document.addEventListener("shopify:section:load", function() {
    hero_slider(); 
})

document.addEventListener("shopify:section:load", function() {
    product_slider(); 
    upsell_slider(); 
    collection_item_slider(); 
    review_slider(); 
})

function hero_slider() {
    let sliderAutoplay = $( ".slider-items" ).data( "slider-autoplay" );
    let sliderDuration = $( ".slider-items" ).data( "slider-duration" ) * 1000;
    let sliderArrow = $( ".slider-items" ).data( "slider-arrow" );
    let sliderDots = $( ".slider-items" ).data( "slider-dots" );

    $('.slider-items').slick({ 
        speed:300,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: sliderAutoplay,
        autoplaySpeed: sliderDuration,
        arrows:sliderArrow,
        dots:sliderDots,
        prevArrow:"<span type='button' class='arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='arrow-next'><img src='"+ arrow +"' alt='arrow'></span>"
    }); 
    console.log('sliderDuration', sliderDuration)
}
// upsell slider 
function upsell_slider() {
    $('.drawer-upsell-items').slick({ 
        speed:300,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows:true,
        dots:false,
        prevArrow:"<span type='button' class='arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='arrow-next'><img src='"+ arrow +"' alt='arrow'></span>"
    }); 
}
// upsell slider 
function collection_item_slider() {
    $('.collection-item-slider').slick({ 
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
        dots:false,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            }
        ]
    }); 
}

// product tab with slider 
function product_slider() {
    $('.product-contents-slider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
        dots:false,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            }
          ]
    })
    // .on('setPosition', function (event, slick) {
    //     slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    // });
}



function review_slider() {
    $('.reviews-items').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='review-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='review-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows:false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false
            }
          }
        ]
    });



}


// product tab in single page 
var el = document.querySelectorAll('ul.info-tab-items li');
var contents = document.querySelectorAll('.product-info-tab-contents .info-tab-content');
for (let i = 0; i < el.length; i++) {
  el[i].onclick = function() {
    var c = 0;
    while (c < el.length) {
      el[c++].className = 'info-tab-item';
    }
    el[i].className = 'info-tab-item active';
    var id = this.getAttribute('data-id');
    var d = 0;
    while (d < contents.length) {
        contents[d++].className = 'info-tab-content';
        if(id == d) {
            contents[i].className = 'info-tab-content show';
        }
    }
  };
}

$(document).ready(function(){
  $('.prescription-btn').on('click', function() {
    $('#custom_file').trigger('click');
  });

  $('#custom_file').on('change', function() {
    var fileName = $(this).val().split('\\').pop(); // Get file name only
    $('.prescription-btn').text(fileName); // Show it inside #file_preview
  });

  // Events that trigger price update
$('#prescription_selector, #lens_selector, #lens_selector_2, #lens_selector_3').on('change', updateTotalPrice);
$('.choose-lens-power').on('change', updateTotalPrice);
$('#productSelect').on('change', updateTotalPrice);

// Optional: Call on page load
$(document).ready(updateTotalPrice);


$('#prescription_selector').on('change', function () {
  // Reset all selector values and hide them
  $('#lens_selector, #lens_selector_2, #lens_selector_3').val("").hide();

  var val = $(this).val();
  var selectorToShow;

  if (val === 'zero Power') {
    selectorToShow = '#lens_selector';
  } else if (val === 'unifocal') {
    selectorToShow = '#lens_selector_2';
  } else if (val === 'progressive') {
    selectorToShow = '#lens_selector_3';
  }

  if (selectorToShow) {
    $(selectorToShow).show();

    // Select the first option (not the placeholder)
    var firstOption = $(selectorToShow + ' option').eq(0); // skip placeholder
    if (firstOption.length) {
      $(selectorToShow).val(firstOption.val());
    }
  }

  // Update hidden input if needed
  $('#prescription_type').val(val);

  // Update total price
  updateTotalPrice();
});


  
  $('#lens_selector, #lens_selector_2').on('change', function () {
    updateTotalPrice();
  });
  
  $('.lens_type').on('change', function () {
    updateTotalPrice();
  });
  

  // $('#prescription_selector').on('change', function() {

  //   var val = $(this).val(); // Get file name only;
  //   if(val == 'progressive') {
  //     $('#lens_selector_2').show();
  //     $('#lens_selector').hide();
  //   }else{
  //     $('#lens_selector_2').hide();
  //     $('#lens_selector').show();
  //   }
  //   // $('#prescription_type').val(val); // Show it inside #file_preview
  // });

  $('#lens_selector').on('change', function() {
    var val = $(this).val(); // Get file name only
    // $('#lens_specification').val(val); // Show it inside #file_preview
  });


  function updateTotalPrice() {
    var basePrice = parseFloat($('#productSelect option:selected').data('price')) || 0;
    var totalPrice = basePrice;
  
    var isPowerLens = $(".choose-lens-power").is(":checked");
    var prescriptionType = $("#prescription_selector").val();
  
    // Hide all selectors first
    $('#lens_selector, #lens_selector_2, #lens_selector_3').hide();
  
    // Determine active selector based on prescription type
    var lensSelector = '';
    if (prescriptionType === 'zero Power') {
      lensSelector = '#lens_selector';
    } else if (prescriptionType === 'unifocal') {
      lensSelector = '#lens_selector_2';
    } else if (prescriptionType === 'progressive') {
      lensSelector = '#lens_selector_3';
    }
  
    // Show only the active selector
    $(lensSelector).show();
  
    // Get selected lens price
    var selectedLens = $(lensSelector + ' option:selected');
    var lensPrice = parseFloat(selectedLens.data("price")) || 0;
  
    if (isPowerLens && selectedLens.val() !== "") {
      totalPrice += lensPrice;
    }

  
    $(".atc-price").text(currency + totalPrice.toFixed(2));
  }
  
  // mobile menu drawer

  $(".header-menu-btn").click(function (event) {
    event.stopPropagation();
    $(".mobile-menu-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
  });


  $(".mobile-menu-wrapper-inner, .ham-menu").on("click", function (e) {
    e.stopPropagation();
    $(".mobile-menu-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
  });

  $(".mobile-drop-down-menu").on("click", function () {
    // $(this).children(".mobile-drop-down-menu-wrapper").slideToggle();
    // $(this).children(".drop-down-menu-btn").toggleClass('active');

    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });

  // mobile mega-menu item - js
  $(".mobile-dropdown-mega-menu-item").on("click", function (e) {
    $(this).children(".mobile-drop-down-mega-menu-items").slideToggle();
    $(this).children(".mobile-dropdown-mega-menu-btn").toggleClass("active");
  });

  //..navbar mobile-menu js end..//

  // sticky bar in product page
  $(window).on('scroll resize', function () {
      let target = $('.regular_atc');
      let alternate = $('.sticky-button');
      let footer = $('footer'); // or use a more specific selector

      // Check if screen width is less than 992px
    if ($(window).width() < 992) {
      let targetRect = target[0].getBoundingClientRect();
      let footerRect = footer[0].getBoundingClientRect();
      let inTargetView = targetRect.top >= 0 && targetRect.bottom <= $(window).height();
      let inFooterView = footerRect.top < $(window).height() && footerRect.bottom > 0;

      if (!inTargetView && !inFooterView) {
        alternate.fadeIn();
      } else {
        alternate.fadeOut();
      }
    }else{
      // Hide on larger screens
      alternate.fadeOut();
    }
  });


  

})

    // upload file and save server 
    const fileInput = document.getElementById("custom_file");
    const hiddenInput = document.getElementById("prescription_file");
    const form = fileInput.closest("form");
    
    fileInput.addEventListener("change", function (event) {
      const file = event.target.files[0];
      const formData = new FormData();
    
      // Replace with your Cloudinary info
      const cloudName = 'dsiahgq5d';
      const uploadPreset = 'Shopify_Upload';
    
      formData.append("file", file);
      formData.append("upload_preset", uploadPreset);
    
      const previewContainer = document.getElementById("file_preview");
      previewContainer.innerHTML = "<p>Uploading...</p>";
    
      fetch(`https://api.cloudinary.com/v1_1/${cloudName}/upload`, {
        method: "POST",
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.secure_url) {
          console.log("Uploaded to Cloudinary:", data.secure_url);
    
          // Set the hidden input value
          hiddenInput.value = data.secure_url;
    
          // Show preview
          const img = document.createElement("img");
          img.src = data.secure_url;
          img.style.marginTop = "10px";
          previewContainer.innerHTML = "";
          previewContainer.appendChild(img);
        } else {
          previewContainer.innerHTML = "<p style='color:red;'>Upload failed. Please try again.</p>";
        }
      })
      .catch(err => {
        console.error("Upload failed:", err);
        previewContainer.innerHTML = "<p style='color:red;'>Upload failed. Please try again.</p>";
      });
    });
    
    // Prevent submitting without file upload done
    form.addEventListener("submit", function (event) {
      if (!hiddenInput.value) {
        event.preventDefault();
        alert("Please upload your file first!");
      }
    });


